/**
 * Redirect delle route storiche /triage… verso /tickets… (la pagina è stata rinominata).
 * Conserva sotto-path, query e hash: /triage/abc?cve=X#all-cves → /tickets/abc?cve=X#all-cves.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { legacyTriageRedirectTarget } from '../features/triage/routes.js';

export function LegacyTriageRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={legacyTriageRedirectTarget(pathname, search, hash)} replace />;
}
